import { fetcher } from "utils";

import { GetDiscountCouponsCheckIssuableResponse } from "typings";

type GetDiscountCouponsCheckIssuable = (ids: number[]) => Promise<GetDiscountCouponsCheckIssuableResponse>;

export const get__discount_coupons__check_issuable: GetDiscountCouponsCheckIssuable = ids =>
  fetcher.get("/discount_coupons/check_issuable", { ids });
